import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CdkTableModule } from '@angular/cdk/table';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { GridsterModule } from 'angular-gridster2';
import { DynamicModule } from 'ng-dynamic-component';

import { FuseSharedModule } from '@fuse/shared.module';

import { ComponentsModule } from '../../../components/components.module';

import { SubjectDialogComponent } from './subject-dialog/subject-dialog.component';

// Note that we need to import the widget module which 'wraps up' the reference to the widget components...
import { PhoenixPipesModule } from '../../../pipes/pipes';
import { SharedModule } from '../../../shared/shared.module';

import { WidgetModule } from '../../widgets/widget.module';
import { ThemeEmitterModule } from 'app/components/theme-emitter/theme-emitter.module';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { SubjectComponentsModule } from './subject-components.module';
import { PrintSubjectDialogComponent } from './print-subject-dialog/print-subject-dialog.component';
import { BatchReassignCaseDialogComponent } from './batchReassignCase-dialog/batchReassignCase-dialog.component';

@NgModule({
    declarations: [
        SubjectDialogComponent,
        BatchReassignCaseDialogComponent,
        PrintSubjectDialogComponent,
    ],
    imports: [
        CdkTableModule,
        MatIconModule,
        MatButtonModule,
        MatRippleModule,
        MatSlideToggleModule,
        MatSidenavModule,
        MatTableModule,
        MatInputModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatSortModule,
        MatTabsModule,
        MatToolbarModule,
        MatMenuModule,
        MatStepperModule,
        MatTooltipModule,
        MatDividerModule,
        WidgetModule,
        GridsterModule,
        DynamicModule,
        ComponentsModule,
        FuseSharedModule,
        SharedModule,
        PhoenixDirectivesModule,
        PhoenixPipesModule.forRoot(),
        ThemeEmitterModule,
        SubjectComponentsModule,
    ],
    providers: [],
    exports: []
})

export class SubjectModule {
}
